import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDeleteAirports } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useDeleteAllAirports = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAllAirports, isPending } = useMutation({
        mutationFn: massDeleteAirports,
        onSuccess: (res) => {
            const message = res?.message || "Airports deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete airports");
        },
    });

    return { deleteAllAirports, isDeleteAll: isPending };
};

export default useDeleteAllAirports;
